export const AUTH_LOGIN_PATH = '/auth/login';
